import React, { useContext } from 'react'
import { useIntl } from 'react-intl'

// utils
import { PAGE_LINKS } from '../../../../utils/helper'
import { MyLocationContext } from '../../../../utils/myLocationProvider'

// styles
import * as SC from './DiscoverSalonSectionStyles'
import { HomePageContainer, HomePageSectionLink } from '../../HomePageStyles'
import { BREAKPOINTS_INTS } from '../../../../styles/constants'

// hooks
import useMessages from '../../../../hooks/useMessages'

// types
import { CmsHomepageData } from '../../../../types/types'

type Props = {
	cmsData: CmsHomepageData['discoverSalonData']
}

// component
const DiscoverSalonSection = (props: Props) => {
	const { cmsData } = props
	const { image, title, subtitle } = cmsData

	const { locale } = useIntl()
	const { messages } = useMessages()

	const { myLocation } = useContext(MyLocationContext)

	const sectionLink = PAGE_LINKS['/salons/all'](locale, { ...myLocation })

	const picture = (
		<SC.Picture>
			{/* WebP variants */}
			{image.desktopWebP && <source srcSet={image.desktopWebP} type='image/webp' media={`(min-width: ${BREAKPOINTS_INTS.sm}px)`} />}
			{image.mobileWebP && <source srcSet={image.mobileWebP} type='image/webp' media={`(max-width: ${BREAKPOINTS_INTS.sm - 1}px)`} />}

			{/* JPEG fallback */}
			<source srcSet={image.desktop} media={`(min-width: ${BREAKPOINTS_INTS.sm}px)`} />
			<source srcSet={image.mobile} media={`(max-width: ${BREAKPOINTS_INTS.sm - 1}px)`} />

			{/* Fallback <img> tag for maximum compatibility */}
			<img src={image.desktop} loading='lazy' alt={image.alt} width={640} height={400} />
		</SC.Picture>
	)

	return (
		<section>
			<HomePageContainer>
				<SC.Layout>
					<SC.InfoCol>
						<SC.SectionTitle $marginBottom={'16px'}>{title}</SC.SectionTitle>
						<SC.SectionDescription $marginBottom={'16px'}>{subtitle}</SC.SectionDescription>
						<HomePageSectionLink href={sectionLink}>{messages['discover-salon-section-link']}</HomePageSectionLink>
					</SC.InfoCol>
					<SC.ImageCol>
						{image.link ? (
							<SC.ImageLink href={image.link} target={'_blank'} rel={'noopener noreferrer'}>
								{picture}
							</SC.ImageLink>
						) : (
							picture
						)}
					</SC.ImageCol>
				</SC.Layout>
			</HomePageContainer>
		</section>
	)
}

export default DiscoverSalonSection
